// extracted by mini-css-extract-plugin
export var card = "_ja-5";
export var cardSelected = "_ja-4";
export var image = "_ja-3";
export var modal = "_ja-0";
export var modalContent = "_ja-1";
export var table = "_ja-2";